import React from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import { Table } from "antd";

function generateCSVData(seriesData) {
  if (seriesData.length === 0) return [];

  const csvData = [];

  // create headers
  csvData.push([
    "Exchange Instrument",
    "Account",
    "Symbol",
    "Balance",
    // "User",
    "Action",
    "ActionAt",
    "Description",
  ]);

  // insert data
  seriesData.forEach((eventLogEntry) => {
    const {
      exchangeInstrument,
      tradeAccount,
      symbol,
      balance,
      // adminUser,
      action,
      timestamp,
      description,
    } = eventLogEntry;
    csvData.push([
      exchangeInstrument,
      tradeAccount,
      symbol,
      balance,
      // adminUser,
      action,
      timestamp,
      description,
    ]);
  });

  return csvData;
}

const EventLogsTable = ({ eventLogs }) => {
  eventLogs.forEach((log) => delete log.adminUser); // hide adminUser info from frontend - https://eonlabs.atlassian.net/browse/EI-510

  const columns = [
    {
      title: "Exchange Instrument",
      dataIndex: "exchangeInstrument",
      key: "exchangeInstrument",
    },
    {
      title: "Account",
      dataIndex: "tradeAccount",
      key: "tradeAccount",
    },
    {
      title: "Symbol",
      dataIndex: "symbol",
      key: "symbol",
    },
    {
      title: "Balance",
      dataIndex: "balance",
      key: "balance",
    },
    // START_TRADE does not record leverage, skip it for now
    // {
    //   title: "Leverage",
    //   dataIndex: "leverage",
    //   key: "leverage",
    // },

    // hide adminUser info from frontend - https://eonlabs.atlassian.net/browse/EI-510
    // {
    //   title: "User",
    //   dataIndex: "adminUser",
    //   key: "adminUser",
    // },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
    },
    {
      title: "ActionAt",
      dataIndex: "timestamp",
      key: "timestamp",
      render: (utcTimeStr) => new Date(utcTimeStr).toLocaleString(),
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a.timestamp) - new Date(b.timestamp),
    },
  ];

  return (
    <>
      <CSVLink
        data={generateCSVData(eventLogs)}
        separator={";"} // escape comma so that the description field won't get divided into many columns
        filename={`EventLogs-${new Date().toISOString()}.csv`}
      >
        <DownloadOutlined style={{ marginRight: 5 }} />
        Download csv
      </CSVLink>
      <Table rowKey="timestamp" bordered dataSource={eventLogs?.reverse()} columns={columns} pagination={{ pageSize: 10 }} />
    </>
  );
};
export default EventLogsTable;
